const handleDeleteEquipment = {
  confirm1: 'Deseja realmente deletar o equipamento',
  confirm2: 'Todos os Serviços e Ações relacionadas a esse equipamento serão deletadas.',
  confirm3: 'Deseja realmente deletar os equipamentos',
  title: 'DELETAR EQUIPAMENTO',
  title2: 'DELETAR EQUIPAMENTOS',
};

export default handleDeleteEquipment;
